import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import useSubAdminData from "Views/people/SubAdmin/data/subAdminData";
import { useState, useEffect } from "react";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import PaginationBar from "components/PaginationBar/PaginationBar";

function Tables() {
  const [refresh, setRefresh] = useState(false); // trigger table refresh
  const [searchQuery, setSearchQuery] = useState(""); // search state

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Handle status toggle
  const handleStatusToggle = (id, newStatus) => {
    // const token = localStorage.getItem("token");
    axios
      .put(`${baseURL}/user/${id}`, { isActive: newStatus })
      .then((res) => {
        console.log("✅ Sub-admin status updated:", res.data);
        toast.success(`Sub-admin ${newStatus ? "activated" : "deactivated"} successfully!`);
        setRefresh((prev) => !prev); // refresh table data
      })
      .catch((err) => {
        toast.error("Failed to update sub-admin status. Please try again.");
        console.error("❌ Error updating sub-admin status:", err);
        console.error("❌ Error response:", err.response?.data);
      });
  };

  const { columns, rows, loading, totalItems } = useSubAdminData(
    handleStatusToggle,
    refresh,
    currentPage,
    rowsPerPage,
    searchQuery
  );

  // Search handler
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Pagination handlers
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1); // Reset to first page when changing rows per page
  };

  const tabsData = [
    { label: "All", count: 92, color: "#2027e1ff", content: "" },
    { label: "Active", count: 12, color: "#ec3c10ff", content: "" },
    { label: "Hold", count: 22, color: "#ec10c7ff", content: "" },
    { label: "Completed", count: 72, color: "#10a6ecff", content: "" },
    { label: "Discontinued", count: 88, color: "#1a6808b7", content: "" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonTypography mb={2} variant="h6">
                  All Sub-Admin List
                </ArgonTypography>
                <ArgonBox display="flex" alignItems="center">
                  <ArgonInput
                    placeholder="Search by name or email"
                    name="search"
                    size="small"
                    type="text"
                    variant="outlined"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ margin: "10px" }}
                  />
                  <ArgonButton
                    color="primary"
                    component={Link}
                    to="/subadmin/adduser"
                    variant="contained"
                    size="small"
                  >
                    +Add
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <ArgonBox textAlign="center" py={4}>
                  <ArgonTypography variant="h6" color="text" fontWeight="medium">
                    Fetching sub-admins...
                  </ArgonTypography>
                  <ArgonTypography variant="caption" color="secondary">
                    Please wait while we load the latest data.
                  </ArgonTypography>
                </ArgonBox>
              ) : rows.length > 0 ? (
                <Table columns={columns} rows={rows} />
              ) : (
                <ArgonBox textAlign="center" py={4}>
                  <ArgonTypography variant="h6" color="text" fontWeight="medium">
                    {searchQuery
                      ? "No sub-admins found matching your search"
                      : "No sub-admins found"}
                  </ArgonTypography>
                  <ArgonTypography variant="caption" color="secondary">
                    {searchQuery
                      ? "Try adjusting your search terms."
                      : "No sub-admin data available."}
                  </ArgonTypography>
                </ArgonBox>
              )}
            </ArgonBox>

            {/* Pagination Controls */}
            {totalItems > rowsPerPage && (
              <PaginationBar
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}
          </Card>
        </ArgonBox>
      </ArgonBox>

      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
